// src/components/NavBar.js
import { NavLink, Link } from "react-router-dom";

function NavBar() {
  return (
    <nav className="navbar navbar-expand-lg mb-4 app-navbar">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <strong>dLabs I </strong>
        </Link>

        {/* Toggle button for mobile screens */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsing Navbar links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <div className="navbar-nav">
            <NavLink
              className={({ isActive }) =>
                "nav-link" + (isActive ? " active" : "")
              }
              to="/jsonlint"
              end
            >
              JSON Tool
            </NavLink>
            <NavLink
              className={({ isActive }) =>
                "nav-link" + (isActive ? " active" : "")
              }
              to="/base64decode"
              end
            >
              Base64 Tool
            </NavLink>
            <NavLink
              className={({ isActive }) =>
                "nav-link" + (isActive ? " active" : "")
              }
              to="/jsontocsv"
              end
            >
              JSON to CSV
            </NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
